(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskFilterSettings',
	};

	var form_id   = 'taskfiltersettings-';
	var form_name = 'form_component_data[' + form.name + ']';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var filter_id         = $('#' + form_id + 'task_filter_id').val();
		var drag_container    = document.querySelector('.task-filter-' + filter_id + ' .filter-columns');
		var $filter_container = $('.task-filter-' + filter_id);
		var picker_color      = $filter_container.find('#' + form_id + 'existing_color').first().val();

		// init dragging of column names
		var drake = dragula([drag_container]);

		// changing the order of the columns
		drake.on('drop', function onDrop(el, target, source, sibling)
		{
			_setColumnOrder($filter_container);
		});

		// handlers to remove a column
		$filter_container.find('.remove-task-column').on('click', function removeColumn(e)
		{
			var $self       = $(this);
			var column_name = $self.parent('li').find('input.column-name').first().val();

			e.preventDefault();

			$self.parent('li').remove();
			_setColumnOrder($filter_container);
			_addColumnToDropdown($filter_container, column_name);
		});

		// init color picker
		$filter_container.find('#colorpicker').first().spectrum({
			color      : picker_color,
			showInitial: true,
			showInput  : true,
			change     : function changeColor(color) {
				var new_color = color.toHexString().toUpperCase();
				$('#' + form_id + 'filter_color').val(new_color);
			}
		});

		// adding a column
		$filter_container.find('select.add-filter-column').first().on('change', function onAddColumnChange(e)
		{
			var $self = $(this);

			if ($self.val() === '') {
				return;
			}

			_removeColumnFromDropdown($filter_container, $self.val());
		});

		// cancel link
		$filter_container.find('.cancel-settings-btn').first().on('click', function onCancelClick(e)
		{
			e.preventDefault();

			$filter_container.find('.task-filter-tasks').removeClass('hidden');

			// set container back to default state
			$filter_container.find('.task-filter-settings').addClass('hidden').html('Loading task filter panel settings form...');
		});
	};

	function _addColumnToDropdown($filter_container, column_name)
	{
		var $add_column_select  = $filter_container.find('select.add-filter-column').first();
		var $avail_column_field = $filter_container.find('div.available-column-field').first();

		if (!column_name) {
			return;
		}

		// show the select field in case it's hidden
		$filter_container.find('.available-column-field').first().removeClass('hidden');

		$add_column_select.append($('<option>', {
			value: column_name,
			text : Adzuki.String.capitalize(column_name),
		}));

		_setColumnOrder($filter_container);
		$avail_column_field.removeClass('hidden');
		$add_column_select.val('');
	}

	function _removeColumnFromDropdown($filter_container, column_name)
	{
		var $add_column_select = $filter_container.find('select.add-filter-column').first();
		var $columns           = $filter_container.find('.filter-columns').first();
		var $new_column        = $columns.find('li').last().clone(true);
		var next_index         = $columns.find('li').length;

		// remove option from select input
		$add_column_select.find('option[value="' + column_name + '"]').remove();

		// hide it if there's no other columns there
		if ($add_column_select.find('option').length <= 1) {
			$filter_container.find('.available-column-field').first().addClass('hidden');
		}

		// update hidden fields and column name on the new column row inserted
		$new_column.find('span').first().text(Adzuki.String.capitalize(column_name));
		$new_column.find('a').first().attr('title', 'Remove ' + Adzuki.String.capitalize(column_name) + ' Column');

		$new_column.find('input.column-name').first()
			.attr('name', form_name + '[columns][' + next_index + '][name]')
			.attr('id', form_id + 'columns-' + next_index + '-name')
			.val(column_name);

		$new_column.find('input.column-order').first()
			.attr('name', form_name + '[columns][' + next_index + '][order]')
			.attr('id', form_id + 'columns-' + next_index + '-order')
			.val(next_index);

		$columns.append($new_column);

		_setColumnOrder($filter_container);
	}

	function _setColumnOrder($filter_container)
	{
		var $columns = $filter_container.find('.filter-columns').first();

		$columns.find('li').each(function onEachColumn(i, elem)
		{
			$(elem).find('input.column-name').first()
				.attr('name', form_name + '[columns][' + i + '][name]')
				.attr('id', form_id + 'columns-' + i + '-name');

			$(elem).find('input.column-order').first()
				.attr('name', form_name + '[columns][' + i + '][order]')
				.attr('id', form_id + 'columns-' + i + '-order')
				.val(i+1);
		});
	}
}(jQuery, window.Adzuki || {}));
